import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IoNotificationsOutline } from "react-icons/io5";
import { resolvePageMeta } from "./pageMeta";
import { useChat } from "../../../modules/chat/ChatContext";
import "./topbar.css";

// Инициалы для кружка-аватара: «Иванов Иван» → «ИИ», «Иван» → «ИВ».
const getInitials = (name) => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

/**
 * Верхняя панель контента: заголовок страницы, уведомления и текущий пользователь.
 * Без фона и без sticky — обычный поток, прокручивается вместе со страницей.
 */
function Topbar({ client }) {
  const { t } = useTranslation("menu");
  const { pathname } = useLocation();
  const { unread = 0, open: chatOpen, setOpen: setChatOpen } = useChat() || {};
  const user = client?.user || {};
  const isAuthorized = user.id != null;
  const name = user.name || t("user.fallbackName");

  const meta = resolvePageMeta(pathname);
  const title = meta ? t(meta.title) : "";
  const sub = meta ? t(`sub.${meta.sub}`) : "";

  return (
    <header className="topbar container">
      <div className="topbar__titles">
        {title ? <div className="topbar__title">{title}</div> : null}
        {sub ? <div className="topbar__sub">{sub}</div> : null}
      </div>

      <div className="topbar__spacer" />

      {/* Слот для кнопок действий страницы (заполняется через TopbarAction) */}
      <div className="topbar__actions" id="topbar-actions" />

      <button
        type="button"
        className={`icon-btn topbar__bell${unread > 0 ? " has-unread" : ""}${
          chatOpen ? " is-open" : ""
        }`}
        onClick={() => setChatOpen?.(!chatOpen)}
        aria-label={t("user.notifications")}
        title={t("user.notifications")}>
        <IoNotificationsOutline size={19} />
        {unread > 0 ? (
          <span className="icon-btn__count">
            {unread > 99 ? "99+" : unread}
          </span>
        ) : null}
      </button>

      {isAuthorized && (
        <div className="user-chip" title={name}>
          <span className="avatar">{getInitials(name)}</span>
          <span className="user-chip__text">
            <span className="user-chip__name">{name}</span>
            {user.login ? (
              <span className="user-chip__role">{user.login}</span>
            ) : null}
          </span>
        </div>
      )}
    </header>
  );
}

export default Topbar;
